/* Firebox backorder handling options - Yes AI, Aug 2026.
 *
 * The question is OPTIONAL and nothing is pre-selected (client's request, 20 Aug), so there is no
 * default to write on load: an unanswered question must reach the order unanswered.
 *
 * What this file still does is save the customer's actual choice the moment they make it. That
 * matters because the radios only reach the order via the cart form, and the dynamic checkout
 * buttons (Shop Pay, PayPal, Google Pay) jump straight to checkout without ever submitting it. On
 * exactly those orders an unsaved choice would be silently dropped.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-fbx-backorder]');
  if (!root) return;

  var status = root.querySelector('[data-fbx-bo-status]');
  var radios = root.querySelectorAll('input[type="radio"][name="attributes[Backorder Handling]"]');
  var clearTimer = null;

  function say(msg, isError) {
    if (!status) return;
    status.textContent = msg;
    status.classList.toggle('fbx-bo__saved--error', !!isError);
    if (clearTimer) window.clearTimeout(clearTimer);
    if (msg && !isError) {
      clearTimer = window.setTimeout(function () { status.textContent = ''; }, 2500);
    }
  }

  function save(value, announce) {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
                   ? window.Shopify.routes.root + 'cart/update.js'
                   : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Backorder Handling': value } })
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      if (announce) say('Saved');
      return res.json();
    }).catch(function () {
      /* Never block checkout on this. The radios still submit with the cart form, so the answer
       * survives the ordinary path even when this request fails. */
      if (announce) say('We could not save that just now. It will still be sent with your order.', true);
    });
  }

  Array.prototype.forEach.call(radios, function (input) {
    input.addEventListener('change', function () {
      if (input.checked) save(input.value, true);
    });
  });
})();
